export class RetryService {
  retriesLeft = 3;

  retryCount = 3;

  timeoutMs = 333;

  fn: any;

  constructor(fn: any) {
    this.fn = fn;
  }

  setRetryCount(n: number) {
    this.retryCount = n;
    return this;
  }

  async delay() {
    return new Promise((resolve) => {
      setTimeout(resolve, this.timeoutMs);
    });
  }

  onSuccess(data: any) {}

  onError(e: any) {}

  setTimeoutMs(ms: number) {
    this.timeoutMs = ms;
  }

  setOnSuccess(fn: any): any {
    this.onSuccess = fn;
    return this;
  }

  setOnError(fn: (err: any) => any): any {
    this.onError = fn;
    return this;
  }

  async run(): Promise<any> {
    return new Promise(async (resolve, reject) => {
      while (this.retriesLeft > 0) {
        if (this.retryCount !== this.retriesLeft) {
          await this.delay();
        }
        console.info(
          "Retrying",
          this.retriesLeft,
          this.fn?.name,
          this.retryCount
        );
        this.retriesLeft -= 1;
        const res = await this.runFn();
        if (!this.retriesLeft && res?.err) {
          this.onError(res.err);
          reject(res.err);
        }
        if (!res?.err) {
          this.retriesLeft = 0;
          this.onSuccess(res.data);
          resolve(res.data);
        }
      }
    });
  }

  async runFn(): Promise<any> {
    try {
      const r = await this.fn();
      return {
        data: r,
      };
    } catch (e) {
      return {
        err: e,
      };
    }
  }
}
